import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-lg-4" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-lg-12 col-xxl-6 col-md-6 col-sm-6" }
const _hoisted_6 = { class: "col-lg-12 col-xxl-6 col-md-6 col-sm-6" }
const _hoisted_7 = { class: "col-lg-12 col-xxl-6 col-md-6 col-sm-6" }
const _hoisted_8 = { class: "col-lg-12 col-xxl-6 col-md-6 col-sm-6" }
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-12 col-xxl-6" }
const _hoisted_12 = { class: "col-lg-12 col-xxl-6" }
const _hoisted_13 = { class: "row justify-content-center" }
const _hoisted_14 = { class: "col-lg-7" }
const _hoisted_15 = { class: "col-lg-5" }
const _hoisted_16 = { class: "row justify-content-center" }
const _hoisted_17 = { class: "col-lg-8" }
const _hoisted_18 = { class: "col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Congratulations = _resolveComponent("Congratulations")!
  const _component_TicketsResolvedChart = _resolveComponent("TicketsResolvedChart")!
  const _component_TicketsInProgressChart = _resolveComponent("TicketsInProgressChart")!
  const _component_TicketsDueChart = _resolveComponent("TicketsDueChart")!
  const _component_TicketsNewOpenChart = _resolveComponent("TicketsNewOpenChart")!
  const _component_TicketsStatusChart = _resolveComponent("TicketsStatusChart")!
  const _component_CustomerSatisfactionChart = _resolveComponent("CustomerSatisfactionChart")!
  const _component_ResponseTimeChart = _resolveComponent("ResponseTimeChart")!
  const _component_PerformanceOfAgents = _resolveComponent("PerformanceOfAgents")!
  const _component_NewAndSolvedTicketsChart = _resolveComponent("NewAndSolvedTicketsChart")!
  const _component_RecentCustomerRatings = _resolveComponent("RecentCustomerRatings")!
  const _component_ToDoList = _resolveComponent("ToDoList")!
  const _component_SupportOverviewChart = _resolveComponent("SupportOverviewChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Congratulations),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_TicketsResolvedChart)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_TicketsInProgressChart)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_TicketsDueChart)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_TicketsNewOpenChart)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_TicketsStatusChart),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_CustomerSatisfactionChart)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_ResponseTimeChart)
          ])
        ])
      ])
    ]),
    _createVNode(_component_PerformanceOfAgents),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_NewAndSolvedTicketsChart)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_RecentCustomerRatings)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_ToDoList)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_SupportOverviewChart)
      ])
    ])
  ]))
}